<template>
  <div class="key-search-page">
    <div class="venom-panel search-panel">
      <div class="search-panel-content">
        <el-input
          ref="searchInput"
          :maxlength="10"
          placeholder="请输入关键字"
          v-model="keyword"
          @keyup.enter.native="search"
          class="input-with-select"
        >
          <el-button @click="search" class="content-search-btn" slot="append">搜索</el-button>
        </el-input>
      </div>
    </div>
    <div class="venom-panel search-info-panel">
      <div class="info-nav" @click="handleNav(index)" :class="{ select: item.select }" v-for="(item, index) in navList" :key="index">
        {{ item.name }}
      </div>
    </div>
    <div class="venom-panel result-panel">
      <div>
        找到相关结果<span class="result-num">{{ resultNum }}</span>个
      </div>
    </div>
    <div v-if="!isEmpty">
      <div class="venom-panel anchor-panel" v-if="anchorList.length && (selectId == 1 || selectId == 2)">
        <div class="title-item">相关主播</div>
        <div class="live-list live-anchor">
          <router-link class="anchor" :to="`/liveMatchesTwo/${anchor.id}`" v-for="anchor in anchorList" :key="anchor.id">
            <AnchorItem :anchor="anchor"></AnchorItem>
          </router-link>
        </div>
      </div>
      <div class="venom-panel live-panel" v-if="entertainmentList.length && (selectId == 1 || selectId == 3)">
        <div class="title-item">相关直播</div>
        <div class="live-list live-match">
          <div class="live" v-for="live in entertainmentList" :key="live.id">
            <LiveItemHot2 type="live" :live="live" v-if="refresh" />
          </div>
        </div>
      </div>
    </div>
    <Empty v-else text="没有搜索到你想的内容" :img="require('@/assets/img/empty/empty.png')"></Empty>
  </div>
</template>

<script>
import AnchorItem from "@/components/anchor-item/anchor-item";
import LiveItemHot2 from "@/components/live-item/live-item-hot2";
import Empty from "@/components/empty/empty";
import { post } from "../../util/http";
export default {
  components: {
    AnchorItem,
    LiveItemHot2,
    Empty,
  },
  watch: {
    $route(to, from) {
      this.keyword = to.query.keyword || "";
      this.search();
      // console.log("to; ",to);
    },
    entertainmentList() {
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
  },
  data() {
    return {
      refresh: true,
      keyword: "",
      selectId: 1,
      resultNum: 0,
      navList: [
        { id: 1, name: "综合", select: true },
        { id: 2, name: "主播" },
        { id: 3, name: "直播" },
      ],
      anchorList: [],
      entertainmentList: [],
      isEmpty: false,
    };
  },
  created() {
    this.keyword = this.$route.query.keyword || "";
  },
  mounted() {
    this.search();
    this.$refs.searchInput.focus();
  },
  methods: {
    search() {
      if (this.keyword.length > 10) {
        this.$message({
          showClose: true,
          message: "搜索内容最多10个字",
          type: "warning",
        });
        return;
      }
      post({
        url: "/api/search",
        data: {
          type: 0,
          keyword: this.keyword,
        },
      })
        .then(({ data: { data } }) => {
          const { lives = [], anhor = [] } = data;
          let totalNum = (lives?.length || 0) + (anhor?.length || 0);
          this.resultNum = (lives?.length || 0) + (anhor?.length || 0);
          switch (this.selectId) {
            case 1:
              this.resultNum = totalNum;
              break;
            case 2:
              this.resultNum = anhor?.length || 0;
              break;
            case 3:
              this.resultNum = lives?.length || 0;
              break;
          }
          if (totalNum == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          this.anchorList = anhor || [];
          this.entertainmentList = lives || [];
        })
        .catch((err) => console.log("err: ", err));
    },
    handleNav(index) {
      let navList = [...this.navList];
      navList.forEach((v, i) => {
        if (index == i) {
          this.selectId = v.id;
          v.select = true;
        } else {
          v.select = false;
        }
      });
      switch (this.selectId) {
        case 1:
          this.resultNum = this.anchorList?.length + this.entertainmentList?.length;
          break;
        case 2:
          this.resultNum = this.anchorList?.length;
          break;
        case 3:
          this.resultNum = this.entertainmentList?.length;
          break;
      }
      this.navList = navList;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '../../assets/public.css';
@import '../../assets/variable.styl';
.key-search-page{
  // margin-bottom: 40px;
  padding-top: 101px;
  padding-bottom: 40px;
  // min-height: 100vh;
  width: 100%;
  background: #fff;
  .venom-panel{
    width : 1232px;
		margin : 0 auto;
  }
  .search-panel-content{
    display : flex;
    justify-content : center;
    align-items : center;
    .el-input{
      width : 400px;
      /deep/{
        .el-input__inner{
          height : 40px;
          border-color: #26D99D;
          border-top-left-radius : 20px;
          border-bottom-left-radius : 20px;
        }
        .el-input-group__append{
          border-color: #26D99D;
          background : #26D99D;
          border-top-right-radius : 20px;
          border-bottom-right-radius : 20px;
          color : #ffffff;
          font-weight : 500;

        }
      }
    }
  }

  .search-info-panel{
    display : flex;
    position : relative;
    padding : 20px 0px;
    &::before{
      display : block;
      content : "";
      position : absolute;
      height : 1px;
      left : 0px;
      right : 0px;
      bottom : 0px;
      background: rgba(0,0,0,0.04);
    }
    .info-nav{
      font-size: 18px;
      color: #666666;
      letter-spacing: 0;
      font-weight: 400;
      margin-right : 22px;
      cursor : pointer;
      &.select,&:hover{
        color : #26D99D;
      }
    }
  }

  .result-panel{
    font-size: 18px;
    color: #666666;
    margin-top : 20px;
    margin-bottom : 20px;
    .result-num{
      color : #26D99D;
    }
  }
  .anchor-panel{
    .title-item{
      padding: 16px 0px;
      padding-top : 20px;
      font-size: 24px;
      color: #333;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .live-panel{
    .title-item{
      padding: 16px 0px;
      padding-top : 30px;
      font-size: 24px;
      color: #333;
      letter-spacing: 0;
      font-weight: 500;
    }
  }

  .live-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content : flex-start;
    .live {
      // box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2);
      // height: 234px;
      transition: all .2s;
      &:hover {
        // transform: scale(1.05);
      }
    }
  }
  .live-match .live{
    width: 296px;
    margin: 0 16px 16px 0;
    // padding : 5px;
    box-sizing : border-box;
    &:nth-child(4n) {
      margin-right: 0px;
    }
  }
  .live-anchor .anchor{
    width: 16.6%;
    box-sizing : border-box;
    //margin: 0 16px 16px 0;
    padding : 6px;
    &:nth-child(6n) {
      //margin-right: 0px;
    }
  }
}
</style>
